import { useEffect, useState } from 'react';
import * as api from '../api/client';

export default function SettingsPage() {
  const [form, setForm] = useState({
    siteName: '',
    whatsappNumber: '',
    defaultWhatsappMessage: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const data = await api.getSettings();
        setForm({
          siteName: data.siteName ?? '',
          whatsappNumber: data.whatsappNumber ?? '',
          defaultWhatsappMessage: data.defaultWhatsappMessage ?? '',
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      await api.updateSettings({
        siteName: form.siteName.trim(),
        whatsappNumber: form.whatsappNumber.replace(/\D/g, ''),
        defaultWhatsappMessage: form.defaultWhatsappMessage.trim(),
      });
      setSuccess('Ayarlar kaydedildi');
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <p>Yükleniyor…</p>
      </div>
    );
  }

  return (
    <>
      <header className="admin-header">
        <h2>Site Ayarları</h2>
        <p>Marka adı ve iletişim bilgilerini düzenleyin</p>
      </header>

      <div className="admin-content">
        {error && <div className="admin-alert admin-alert--error">{error}</div>}
        {success && <div className="admin-alert admin-alert--success">{success}</div>}

        <div className="admin-card">
          <form className="admin-form" onSubmit={handleSave}>
            <div className="admin-field">
              <label htmlFor="set-name">Site adı</label>
              <input id="set-name" value={form.siteName} onChange={(e) => setForm({ ...form, siteName: e.target.value })} />
            </div>
            <div className="admin-field">
              <label htmlFor="set-wa">WhatsApp numarası</label>
              <input id="set-wa" value={form.whatsappNumber} onChange={(e) => setForm({ ...form, whatsappNumber: e.target.value })} placeholder="905551234567" />
              <span className="admin-field__hint">Ülke kodu dahil, yalnızca rakam</span>
            </div>
            <div className="admin-field">
              <label htmlFor="set-wa-msg">Varsayılan WhatsApp mesajı</label>
              <textarea id="set-wa-msg" value={form.defaultWhatsappMessage} onChange={(e) => setForm({ ...form, defaultWhatsappMessage: e.target.value })} />
            </div>
            <div className="admin-form-actions">
              <button type="submit" className="admin-btn admin-btn--primary" disabled={saving}>
                {saving ? 'Kaydediliyor…' : 'Kaydet'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
